/* Luxe layer: scroll reveal (respects prefers-reduced-motion) */
window.__luxeReady = true;
(function () {
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
    root.classList.remove('luxe-js');
    return;
  }
  function init() {
    var els = document.querySelectorAll('[data-luxe-reveal]:not(.is-visible)');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
    // Safety net: never leave content hidden
    setTimeout(function () {
      document.querySelectorAll('[data-luxe-reveal]:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add('is-visible');
      });
    }, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
